module.exports = __webpack_public_path__ + "img/relais-sm.4d1ad4af.svg";